import { useCallback, useRef } from 'react';

const useDebounce = () => {

  const timeoutRef = useRef(null);

  const createDebounce = useCallback((callback, delay) => {
    return (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(...args);
        timeoutRef.current = null;
      }, delay);
    };
  }, []);

  const cancel = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  return { createDebounce, cancel };
};

export default useDebounce;
